module.exports = __webpack_public_path__ + "static/img/24.f7939ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/24.png
// module id = SZC1
// module chunks = 6